// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IFieldStateType {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN'
}


export function instanceOfIFieldStateType(value: any): boolean {
    for (const key in IFieldStateType) {
        if (Object.prototype.hasOwnProperty.call(IFieldStateType, key)) {
            if (IFieldStateType[key as keyof typeof IFieldStateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IFieldStateTypeFromJSON(json: any): IFieldStateType {
    return IFieldStateTypeFromJSONTyped(json, false);
}

export function IFieldStateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFieldStateType {
    return json as IFieldStateType;
}

export function IFieldStateTypeToJSON(value?: IFieldStateType | null): any {
    return value as any;
}

export function IFieldStateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): IFieldStateType {
    return value as IFieldStateType;
}

